module.exports = __webpack_public_path__ + "static/media/searches.ed806b82.svg";